import { ApolloError } from '@apollo/client';

const GRPC_ERROR_CODE = 'GRPC_ERROR';
const GRPC_PERMISSION_DENIED_EXCEPTION_CODE = 7;

/** Determines whether the ApolloError includes a gRPC permission error */
export const hasPermissionDeniedError = (apolloError: ApolloError | undefined): boolean =>
  apolloError?.graphQLErrors.some(
    (error) =>
      error.extensions?.code === GRPC_ERROR_CODE &&
      error.extensions?.exception?.code === GRPC_PERMISSION_DENIED_EXCEPTION_CODE,
  ) || false;
